import { z } from "zod";

const zPossiblyEmptyName = z
  .string()
  .trim()
  .max(2 ** 6);

const zPossiblyEmptyDescription = z
  .string()
  .trim()
  .max(2 ** 9);

const zSchema = z.object({
  id: z.string().uuid(),
  name: zPossiblyEmptyName.nonempty(),
  description: zPossiblyEmptyDescription.nonempty(),
});
type Schema = z.infer<typeof zSchema>;

export { zPossiblyEmptyDescription, zPossiblyEmptyName, zSchema };
export type { Schema };
